import { createAction } from 'typesafe-actions';
import { DmWalCurveSecurityState } from '../types/state/DmWalCurveState';
import { DateTimeStamp } from '../types/primitives/DateTimeStamp';

const show = createAction("dm-wal-curve/SHOW",
    resolve => (position: DmWalCurveSecurityState, bwicDate?: Date | DateTimeStamp) => resolve({ position, bwicDate }));
const hide = createAction("dm-wal-curve/HIDE");

export const dmWalCurveActions = {
    show,
    hide
}
